import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=648b50a8&scoped=true"
import script from "./DownloadList.vue?vue&type=script&lang=ts"
export * from "./DownloadList.vue?vue&type=script&lang=ts"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=648b50a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648b50a8",
  null
  
)

export default component.exports